import { ChangeDetectorRef, Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { FirebaseService } from 'src/app/services/firebase.service';

@Component({
  selector: 'app-firmenname',
  templateUrl: './firmenname.component.html',
  styleUrls: ['./firmenname.component.scss'],
  standalone: false
})
export class FirmennameComponent implements OnInit, OnChanges, OnDestroy {
    @Input() clientId: string = '';
    @Input() isLead: boolean = false;
    @Input() showOrt: boolean = false;
    @Input() noLink: boolean = false;
    @Input() showNew: boolean = false;
    @Input() fontSize: string = '14';

    firmenname = '?';
    ort = '';
    newClient = false;

    sub: Subscription = new Subscription();

    constructor(private firebaseService: FirebaseService, private cdr: ChangeDetectorRef) {}

    ngOnChanges(changes: SimpleChanges): void {
        this.getData();
    }

    getData() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
        if (this.isLead) {
            this.sub = this.firebaseService.getLead(this.clientId).subscribe((client) => {
                if (client) {
                    this.firmenname = client.name || client.ansprechpartner;
                    this.ort = client.ort;
                    this.cdr.detectChanges();
                }
            });
        } else {
            this.sub = this.firebaseService.getClient(this.clientId).subscribe((client) => {
                if (client) {
                    this.firmenname = client.name || client.ansprechpartner;
                    this.ort = client.ort;
                    const now = new Date().getTime();
                    const initalBookingAtUnix = client.initalBookingAtUnix || 0;
                    this.newClient = false;
                    if (initalBookingAtUnix) {
                        const since = now - initalBookingAtUnix;
                        const eintag = 1000 * 60 * 60 * 24;
                        this.newClient = !!initalBookingAtUnix && since < eintag * 60;
                    }

                    this.cdr.detectChanges();
                }
            });
        }
    }
    ngOnInit(): void {
        this.getData();
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }
}
